import { SubscriptionServiceModule } from 'services/access/subscription/subscription.service';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { StoreInformationServiceModule } from 'services/data/storeInformation.service';

import './overflowMenu.scss';

const POSITION = {
    TOP: 'top',
    BOTTOM: 'bottom'
};

export const OverflowMenuComponentModule = angular
    .module('app.components.pageHeader.pageHeaderOverflowMenu', [
        SubscriptionServiceModule,
        LaunchDarklyServiceModule,
        StoreInformationServiceModule
    ])
    .component('pageHeaderOverflowMenu', {
        template: `
            <md-menu md-position-mode="target-right target" md-helper>
                <md-button
                    data-cy="overflow"
                    class="md-icon-button header__menu-button"
                    ng-click="$mdMenu.open($event)"
                    gtm-click-event="{{$ctrl.gtmId}}_menu-open">
                    <md-icon>more_vert</md-icon>
                </md-button>
                <md-menu-content class="overflow-menu__content">
                    <ng-transclude ng-if="$ctrl.transcludePosition === $ctrl.POSITION.TOP"></ng-transclude>
                    <overflow-menu-bulk-process
                        ng-if="$ctrl.showOpenUpdateModal"
                        on-click="$ctrl.showOpenUpdateModal()">
                    </overflow-menu-bulk-process>
                    <overflow-menu-search ng-if="$ctrl.showSearchButton"
                        on-click="$ctrl.onSearchButtonClicked()">
                    </overflow-menu-search>
                    <md-divider ng-if="$ctrl.isMobile && $ctrl.showSearchButton"></md-divider>
                    <overflow-menu-help hide-gt-xs></overflow-menu-help>
                    <overflow-menu-intercom hide-gt-xs></overflow-menu-intercom>
                    <overflow-menu-calendly hide-gt-xs ng-if="$ctrl.showCallMenu"></overflow-menu-calendly>
                    <md-divider ng-if="$ctrl.isMobile"></md-divider>
                    <overflow-menu-storefront-preview ng-if="!$ctrl.isElementStore"/>
                    <overflow-menu-logout></overflow-menu-logout>
                    <ng-transclude ng-if="$ctrl.transcludePosition === $ctrl.POSITION.BOTTOM"></ng-transclude>
                </md-menu-content>
            </md-menu>
        `,
        transclude: true,
        bindings: {
            gtmId: '<',
            showCallMenu: '<',
            showOpenUpdateModal: '<',
            showSearchButton: '<',
            onSearchButtonClicked: '&',
            transcludePosition: '<'
        },
        controller: class PageHeaderOverflowMenuCtrl {
            constructor(
                subscriptionsService,
                launchDarklyService,
                storeInformationService,
                $window,
            ) {
                'ngInject';

                angular.extend(this, {
                    subscriptionsService,
                    launchDarklyService,
                    storeInformationService,
                    $window,
                    showCallMenu: false,
                    isMobile: false,
                    POSITION
                });
            }
            $onInit() {
                this.setShowCallMenu();
                const mobileCheck = this.$window.matchMedia('(max-width: 599px)');
                this.isMobile = mobileCheck.matches;
                this.transcludePosition = this.transcludePosition || POSITION.TOP;

                this.launchDarklyService.isElementStore(this.storeInformationService)
                    .then(isElementStore => this.isElementStore = isElementStore);
            }

            setShowCallMenu() {
                this.subscriptionsService.getSubscription()
                    .then((subs) => {
                        this.showCallMenu = subs.features.scheduleCallDisplayed;
                    });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/pageHeader/overflowMenu/overflowMenu.js